/* בול פרקט: הצעות תוך כדי הקלדה בכל תיבת חיפוש באתר (שיחה 07, העתק של סניפט 62).
   החיפוש החי של שופיפיי לא תומך בעברית, ולכן ההצעות באות מהחיפוש הרגיל דרך הסקשן bp-search-suggest. */
(function () {
  'use strict';
  if (window.__bpsl) return; window.__bpsl = 1;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function attach(input) {
    if (input.__bpsl) return; input.__bpsl = 1;
    var form = input.closest('form'); if (!form) return;
    var box = document.createElement('div');
    box.className = 'bpsl'; box.setAttribute('role', 'listbox'); box.hidden = true;
    /* בתוך חלון קופץ (dialog) ההצעות נכנסות לזרימה, כדי שהחלון יגדל ולא יחתוך אותן */
    var inDialog = !!input.closest('dialog');
    var host = inDialog ? form : input.parentElement;
    if (inDialog) box.classList.add('bpsl-flow');
    else if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(box);
    input.setAttribute('autocomplete', 'off');

    var timer, ctrl, last = '', idx = -1;
    function rows() { return [].slice.call(box.querySelectorAll('a.bpsl-row, a.bpsl-all')); }
    function close() { box.hidden = true; idx = -1; }
    function mark(i) { var r = rows(); r.forEach(function (a, k) { a.classList.toggle('on', k === i); }); idx = i; if (r[i]) r[i].scrollIntoView({ block: 'nearest' }); }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { close(); last = ''; return; }
      if (q === last && !box.hidden) return;
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      box.hidden = false; box.classList.add('busy');
      if (!box.firstChild) box.innerHTML = '<div class="bpsl-none">מחפשים...</div>';
      var u = ROOT + 'search?type=product&options%5Bprefix%5D=last&section_id=bp-search-suggest&q=' + encodeURIComponent(q);
      fetch(u, { signal: ctrl.signal, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          if (q !== input.value.trim()) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = doc.querySelector('.bpsl-in');
          box.innerHTML = inner ? inner.outerHTML : '';
          box.classList.remove('busy'); idx = -1;
          box.hidden = !inner;
        })
        .catch(function (e) { if (e.name !== 'AbortError') { box.classList.remove('busy'); close(); } });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 250); });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length > 1) box.hidden = false; });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      var r = rows();
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(Math.min(idx + 1, r.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(Math.max(idx - 1, 0)); }
      else if (e.key === 'Enter' && idx > -1 && r[idx]) { e.preventDefault(); e.stopPropagation(); window.location.href = r[idx].href; }
      else if (e.key === 'Escape') { close(); }
    }, true);
    document.addEventListener('click', function (e) { if (!host.contains(e.target)) close(); });
    /* כל שליחה של טופס חיפוש: מוצרים בלבד, כמו באתר היום */
    form.addEventListener('submit', function () {
      if (!form.querySelector('input[name="type"]')) {
        var t = document.createElement('input'); t.type = 'hidden'; t.name = 'type'; t.value = 'product'; form.appendChild(t);
      }
    });
  }

  /* שורת החיפוש בהדר: ב-Horizon זה כפתור שמעוצב כשורה ופותח חלון קופץ.
     כמו באתר היום, הופכים אותו לשורת חיפוש אמיתית, וההצעות נפתחות מתחתיה.
     נוגעים רק בכפתור שמעוצב כשורה (יש לו טקסט "מה לחפש לך?" מה-CSS של שיחה 04), לא באייקון. */
  function upgradeHeader() {
    [].slice.call(document.querySelectorAll('header search-button')).forEach(function (sb) {
      if (sb.__bpsl) return;
      var btn = sb.querySelector('button'); if (!btn) return;
      var ph = getComputedStyle(btn, '::before').content;
      if (!ph || ph === 'none' || ph === 'normal') return;
      sb.__bpsl = 1;
      ph = ph.replace(/^["']|["']$/g, '') || 'מה לחפש לך?';
      var icon = btn.querySelector('svg');
      var f = document.createElement('form');
      f.className = 'bpsl-hform'; f.action = ROOT + 'search'; f.method = 'get'; f.setAttribute('role', 'search');
      f.innerHTML = '<input type="hidden" name="type" value="product">' +
        '<input type="search" name="q" class="bpsl-hin" autocomplete="off" aria-label="חיפוש">' +
        '<button type="submit" class="bpsl-hbtn" aria-label="חיפוש"></button>';
      f.querySelector('.bpsl-hin').placeholder = ph;
      if (icon) f.querySelector('.bpsl-hbtn').appendChild(icon.cloneNode(true));
      btn.style.display = 'none';
      sb.appendChild(f);
    });
  }

  function scan() {
    upgradeHeader();
    [].slice.call(document.querySelectorAll('form[action$="/search"] input[name="q"], form[action*="/search?"] input[name="q"]')).forEach(attach);
  }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', scan);
  new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });

  var css = document.createElement('style');
  css.textContent =
    '.bpsl{position:absolute;inset-inline:0;top:calc(100% + 6px);z-index:2147483000;background:#fff;border:1px solid #E3E8E4;border-radius:14px;box-shadow:0 14px 40px rgba(13,61,40,.18);max-height:min(70vh,520px);overflow:auto;padding:6px;text-align:start;direction:rtl;color:#1E2A23;font-size:14.5px}' +
    '.bpsl.busy{opacity:.75}' +
    '.bpsl.bpsl-flow{position:relative;top:auto;inset-inline:auto;margin:8px 0 4px;box-shadow:none;max-height:min(65vh,520px)}' +
    '.bpsl-h{font-size:12.5px;font-weight:800;color:#6B766F;padding:8px 10px 4px}' +
    '.bpsl-row{display:flex;align-items:center;gap:10px;padding:7px 10px;border-radius:10px;text-decoration:none;color:inherit}' +
    '.bpsl-row:hover,.bpsl-row.on{background:#F1F5F2}' +
    '.bpsl-row .im{width:48px;height:48px;border-radius:8px;overflow:hidden;background:#F1F3EF;flex:none}' +
    '.bpsl-row .im img{width:100%;height:100%;object-fit:cover;display:block}' +
    '.bpsl-row .tx{display:flex;flex-direction:column;min-width:0;flex:1}' +
    '.bpsl-row .tx b{font-weight:700;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.bpsl-row .tx small{color:#6B766F;font-size:12.5px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.bpsl-row .pr{font-weight:800;color:#0D3D28;white-space:nowrap}' +
    '.bpsl-row .pr small,.bpsl-row .pr .bp-cp-u{font-weight:500;color:#6B766F;font-size:12px}' +
    '.bpsl-cat .tx b{color:#1E6B45}' +
    '.bpsl-all{display:block;margin:6px 4px 2px;padding:10px;border-radius:10px;background:#0D3D28;color:#fff;text-align:center;font-weight:800;text-decoration:none}' +
    '.bpsl-all.on,.bpsl-all:hover{background:#1E6B45}' +
    '.bpsl-none{padding:12px 10px;color:#55625A}' +
    '.bpsl-none a{color:#1E6B45;font-weight:700}' +
    '.bpsl-nf{padding:10px 10px 6px}' +
    '.bpsl-nf-t{display:block;font-size:15.5px;font-weight:800;color:#1E2A23}' +
    '.bpsl-nf-s{color:#55625A;font-size:13.5px;margin:3px 0 10px}' +
    '.bpsl-nf-b{display:flex;gap:8px;margin-bottom:8px}' +
    '.bpsl-nf-btn{flex:1;display:flex;align-items:center;justify-content:center;min-height:44px;border-radius:999px;background:#E9F2EC;color:#0D3D28!important;font-weight:800;text-decoration:none}' +
    '.bpsl-nf-btn:hover{background:#D6E8DC}' +
    '.bpsl-nf .bpsl-h{padding:8px 0 6px}' +
    '.bpsl-nf-p{display:flex;flex-wrap:wrap;gap:7px}' +
    '.bpsl-nf-p a{padding:6px 12px;border-radius:999px;background:#F1F5F2;border:1px solid #DCE6DF;color:#1E6B45;font-size:13.5px;font-weight:600;text-decoration:none}' +
    '.bpsl-nf-p a:hover{background:#E1EEE5}' +
    /* שורת החיפוש בהדר */
    '.bpsl-hform{position:relative;display:flex;align-items:stretch;width:100%;height:35px;background:#fff;border-radius:36px;direction:rtl}' +
    '.bpsl-hform .bpsl-hin{flex:1;min-width:0;height:100%;border:0!important;outline:0;background:transparent!important;box-shadow:none!important;padding:0 16px;margin:0;font:inherit;font-size:18px;font-weight:500;color:#1E2A23;border-radius:36px}' +
    '.bpsl-hform .bpsl-hin::placeholder{color:#777;opacity:1}' +
    '.bpsl-hform .bpsl-hin::-webkit-search-cancel-button{display:none}' +
    '.bpsl-hform .bpsl-hbtn{flex:none;width:35px;height:35px;display:flex;align-items:center;justify-content:center;border:0;padding:0;margin:0;cursor:pointer;background:#69727D;color:#fff;border-start-end-radius:36px;border-end-end-radius:36px}' +
    '.bpsl-hform .bpsl-hbtn::before,.bpsl-hform .bpsl-hbtn::after{content:none!important;display:none!important}' +
    '.bpsl-hform .bpsl-hbtn svg{width:16px;height:16px}' +
    '.bpsl-hform .bpsl{top:calc(100% + 8px);min-width:min(440px,92vw)}';
  document.head.appendChild(css);
})();
